import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const uploadFile = async (data = {}) => (
  axiosRequest({
    url: 'v1/s3/upload',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const deleteFile = async (data = {}) => (
  axiosRequest({
    url: 'v1/s3/delete',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const downloadFile = async (data = {}) => (
  axiosRequest({
    url: 'v1/s3/download',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export {
  uploadFile,
  deleteFile,
  downloadFile,
};
